import { IStorageService } from "../../core/service/StorageService";

const SESSION_IDENTIFIER_STORAGE_KEY = "sessionid";
const LANGUAGE_STORAGE_KEY = "language";

let isLoggedIn: boolean | undefined = undefined;
let username: string = "";
let roles: Array<string> = [];
export interface ICredentialsService {
  setUsername(username: string): void;
  getUsername(): string;
  setIsLoggedIn(value: boolean): void;
  getIsLoggedIn(): Promise<boolean>;
  getSessionIdentifier(): Promise<string | null>;
  getLanguage(): Promise<string>;
  setLanguage(value: string): Promise<void>;
  getRoles(): Promise<string[]>;
}

const CredentialsService = ({ storageService }): ICredentialsService => {
  const _storageService: IStorageService = storageService;

  return {
    setUsername(value: string) {
      username = value;
    },

    getUsername() {
      return username;
    },

    async getIsLoggedIn() {
      if (isLoggedIn !== undefined) {
        return isLoggedIn;
      }
      let value = await storageService.get("loginStatus");

      isLoggedIn = value === "true";
      return isLoggedIn;
    },

    setIsLoggedIn(value: boolean) {
      isLoggedIn = value;
      _storageService.save("loginStatus", value);
    },

    async getSessionIdentifier() {
      return _storageService.get(SESSION_IDENTIFIER_STORAGE_KEY);
    },

    async getLanguage() {
      return _storageService.get(LANGUAGE_STORAGE_KEY);
    },

    async setLanguage(value: string) {
      _storageService.save(LANGUAGE_STORAGE_KEY, value);
    },

    async getRoles() {
      return roles;
    }
  };
};

export default CredentialsService;
